export default "__VITE_ASSET__Bfilb66N__"